import {
  Stage,
  FloorModel,
  OrthographicView,
  CameraController,
  AerialElementController,
  THREE,
  EventHub,
  Events,
  PerspectiveView,
  CameraView,
  Camera,
} from '@aibee/owlly';
import { uuid as calcUUID } from '@/utils/index';

class WorkbenchAssembly {
  constructor(threeDModelContainer, singleContainer, meshId) {
    this.initThreeModelContainer(threeDModelContainer);
    this.initSingleContainer(singleContainer);
    this.initStage(meshId);

    this.listeners = {
      owllyEventCallback: (...args) => {
        this.eventCallback(...args);
      },
    };
  }

  initThreeModelContainer(threeDModelContainer) {
    this.threeDModelContainer = threeDModelContainer;
    this.threeDModelContainer.style.setProperty('height', `${threeDModelContainer.clientHeight}px`);
    // this.threeDModelContainer.style.setProperty("width", `${threeDModelContainer.clientWidth}px`);
  }

  initSingleContainer(singleContainer) {
    this.singleContainer = singleContainer;
    this.singleContainer.style.setProperty('height', `${singleContainer.clientHeight}px`);
    // this.singleContainer.style.setProperty("width", `${singleContainer.clientWidth}px`);
  }

  initStage(meshId) {
    // 初始化stage
    this.stage = new Stage();
    const model = new FloorModel(meshId);
    this.stage.bindElement(model);

    // 初始化view
    this.threeDModelView = new OrthographicView(this.threeDModelContainer);
    this.stage.bindView(this.threeDModelView);

    // 初始化controller
    this.controller = new AerialElementController(this.threeDModelView);
    this.stage.bindController(this.controller);

    // 开启辅助功能
    this.stage.setStatsEnabled(false);
    this.stage.setAxesEnabled(false);
    console.log('init stage');
  }

  initEvent(callback) {
    if (!callback || typeof callback !== 'function') {
      return;
    }
    this.callbackFunc = callback;
    console.log('init event');
    EventHub.on(Events.ELEMENT_POSITION_UPDATED, this.listeners.owllyEventCallback);
    EventHub.on(Events.ELEMENT_POSE_UPDATED, this.listeners.owllyEventCallback);
    EventHub.on(Events.ELEMENT_SELECTED, this.listeners.owllyEventCallback);
  }

  initSingleView() {
    if (!this.singleCameraView) {
      this.singleCameraView = new CameraView(this.singleContainer);
      this.stage.bindView(this.singleCameraView);
      this.cameraController = new CameraController(this.singleCameraView);
      this.stage.bindController(this.cameraController);
    }
  }

  eventCallback(data, uuid) {
    if (data.type === 'Object3D') {
      console.log('select');
      this.callbackFunc('select', null, data.getUUID());
    } else if (Object.keys(data).includes('_w')) {
      console.log(data, uuid);
      this.callbackFunc('pose', data, uuid);
    } else {
      console.log(data, uuid);
      this.callbackFunc('position', data, uuid);
      this.deployingCamera = null;
    }
  }

  removeEvent() {
    console.log('remove event');
    EventHub.remove(Events.ELEMENT_POSITION_UPDATED, this.listeners.owllyEventCallback);
    EventHub.remove(Events.ELEMENT_POSE_UPDATED, this.listeners.owllyEventCallback);
    EventHub.remove(Events.ELEMENT_SELECTED, this.listeners.owllyEventCallback);
  }

  getCameraInstanceByUUID(uuid) {
    const { stage } = this;
    if (!stage) {
      return null;
    }
    const elements = [...stage.elements];
    return elements.filter(e => e.universalId === uuid).pop();
  }

  cancelAddCamera() {
    this.removeCamera(this.deployingCamera);
    this.controller.cancelMoveElement();
    this.deployingCamera = null;
  }

  removeCamera(camera) {
    if (!camera) {
      return;
    }
    this.controller.unbindElement(camera);
    this.stage.disposeElement(camera);
    this.singleCameraView.dispose();
    this.singleCameraView = null;
    // camera = null;
  }

  deleteCamera(uuid) {
    const camera = this.getCameraInstanceByUUID(uuid);
    this.removeCamera(camera);
  }

  selectCamera(uuid) {
    const camera = this.getCameraInstanceByUUID(uuid);
    if (!camera) {
      return;
    }
    camera.select();
    this.initSingleView();
  }

  addCamera(uuid, data) {
    this.deployingCamera = new Camera();
    // 处于当前视图中
    this.initSingleView();
    this.stage.bindElement(this.deployingCamera);
    this.controller.bindElement(this.deployingCamera);

    // 创建camera
    if (uuid) {
      const { x, y, z, rw, rx, ry, rz } = data;
      this.deployingCamera.position.set(x, y, z);
      this.deployingCamera.quaternion.set(rx, ry, rz, rw);

      this.deployingCamera.setUUID(uuid);
      this.deployingCamera = null;
    } else {
      this.deployingCamera.setUUID(calcUUID());
      this.controller.moveElement(this.deployingCamera, true);
    }
  }
}

export default WorkbenchAssembly;
